
import { ProjectManagement } from "../components/Projects/ProjectManagement";

const ProjectManagementPage = () => {
  return <ProjectManagement />;
};

export default ProjectManagementPage;
